import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Divider,
} from '@mui/material';
import {
  CalendarToday as CalendarIcon,
  BuildCircle as BuildIcon,
} from '@mui/icons-material';

const TLMVPSPProject: React.FC = () => {
  return (
    <Box>
      {/* Header avec titre et image */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <img
          src="/TV/TLMVPSP.png"
          alt="Logo Tout le monde veut prendre sa place"
          style={{
            width: '64px',
            height: '64px',
            objectFit: 'contain',
            filter: 'drop-shadow(2px 2px 4px rgba(167, 139, 250, 0.3))',
          }}
        />
        <Typography
          variant="h4"
          component="h2"
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold'
          }}
        >
          Tout le monde veut prendre sa place
        </Typography>
      </Box>

      {/* Statut et date */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CalendarIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">
            2019
          </Typography>
        </Box>
      </Box>

      {/* Description */}
      <Typography
        variant="body1"
        sx={{ mb: 3, lineHeight: 1.6 }}
      >
        Modernisation complète de l'émission "Tout le monde veut prendre sa place" 
        avec mise à jour de l'habillage graphique par intégration d'assets créatifs 
        et développement du système de jeu sur une nouvelle architecture technique, 
        apportant des performances et fonctionnalités améliorées.
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* Missions réalisées */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold'
          }}
        >
          Missions réalisées
        </Typography>
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: 2
        }}>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Intégration nouvel habillage graphique
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Développement sur nouveau système
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Modernisation architecture technique
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Optimisation performances
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Tests et validation système
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Formation équipes techniques
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Support mise en production
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Domaines techniques */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold'
          }}
        >
          Domaines techniques
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {['Nouvelle architecture', 'Intégration graphique', 'Développement système', 'Tests systémiques', 'Support production'].map((tech) => (
            <Chip
              key={tech}
              label={tech}
              variant="filled"
              size="small"
              sx={{
                background: 'linear-gradient(135deg, rgba(167, 139, 250, 0.1) 0%, rgba(20, 184, 166, 0.1) 100%)',
                color: '#a78bfa',
                border: '1px solid rgba(167, 139, 250, 0.3)',
                '&:hover': {
                  background: 'linear-gradient(135deg, rgba(167, 139, 250, 0.2) 0%, rgba(20, 184, 166, 0.2) 100%)',
                },
              }}
            />
          ))}
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Défis techniques */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold'
          }}
        >
          Défis techniques relevés
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Développement sur nouvelle architecture :</strong> Concevoir et implémenter 
          un système de jeu complet sur une plateforme technologique moderne, en optimisant 
          les performances et la maintenabilité.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Intégration graphique complexe :</strong> Intégrer de nouveaux assets 
          créatifs en respectant les contraintes techniques tout en préservant la fluidité 
          et l'identité visuelle de l'émission.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Migration sans interruption :</strong> Assurer la transition vers le 
          nouveau système en maintenant la continuité de production et en préservant 
          toutes les données et configurations existantes.
        </Typography>
        <Typography variant="body2">
          <strong>Performance et fiabilité :</strong> Garantir des performances optimales 
          sur la nouvelle architecture tout en maintenant la fiabilité critique requise 
          pour une émission de divertissement quotidienne.
        </Typography>
      </Box>
    </Box>
  );
};

export default TLMVPSPProject;
